// Global
export const SET_LOADING = "SET_LOADING";
export const IS_APP_LOCKED = "IS_APP_LOCKED";
export const WAS_USER_NOTIFIED = "WAS_USER_NOTIFIED";
export const RESET_GLOBAL = "RESET_GLOBAL";
// AUTH
export const SIGN_IN = "SIGN_IN";
export const LOG_OUT = "LOG_OUT";
export const TOGGLE_LOGIN_BTN_LOADING = "TOGGLE_LOGIN_BTN_LOADING";
export const FETCH_CURRENT_USER = "FETCH_CURRENT_USER";
export const GET_CURRENT_LOCATION = "GET_CURRENT_LOCATION";
export const GET_ACCESS_PAGES = "GET_ACCESS_PAGES";
export const SET_APP_CONFIG_PARAMS = "SET_APP_CONFIG_PARAMS";
export const SET_RED_LENTA_NOTIFICACION = "SET_RED_LENTA_NOTIFICACION";
export const SET_RED_LENTA_NOTIFICACION_DESCARTADO =
  "SET_RED_LENTA_NOTIFICACION_DESCARTADO";
//  buses
export const FETCH_BUSES = "FETCH_BUSES";
export const FETCH_BUSES_APROXIMADOS = "FETCH_BUSES_APROXIMADOS";
export const UPDATE_BUS_SETTING = "UPDATE_BUS_SETTING";
export const UPDATE_SOCKET_BUSES = "UPDATE_SOCKET_BUSES";
export const FETCH_SOCKETS_MODELOS = "FETCH_SOCKETS_MODELOS";
// cargas
export const FETCH_MARQUESINAS = "FETCH_MARQUESINAS";
export const UPDATE_MARQUESINAS_MANUALLY = "UPDATE_MARQUESINAS_MANUALLY";
export const FETCH_MODAL_DATA = "FETCH_MODAL_DATA";
export const SET_MODAL_DATA = "SET_MODAL_DATA";
export const UPDATE_MODAL_DATA = "UPDATE_MODAL_DATA";
export const UNSET_MODAL_DATA = "UNSET_MODAL_DATA";
export const TOGGLE_BTN_MODAL = "TOGGLE_BTN_MODAL";
export const SET_INTERVAL_FETCH_MARQUESINAS = "SET_INTERVAL_FETCH_MARQUESINAS";
export const UNSET_INTERVAL_FETCH_MARQUESINAS =
  "UNSET_INTERVAL_FETCH_MARQUESINAS";
export const GET_STATUS_CONNECTOR = "GET_STATUS_CONNECTOR";
export const GET_STATUS_CONNECTOR_ALL = "GET_STATUS_CONNECTOR_ALL";
export const HANDLE_TECLE = "HANDLE_TECLE";
export const HANDLE_TECLE_TIME = "HANDLE_TECLE_TIME";
export const HANDLE_ALL_TECLES = "HANDLE_ALL_TECLES";
export const STOP_CARGE_INTERNALLY = "STOP_CARGE_INTERNALLY";
export const HANDLE_SYNC = "HANDLE_SYNC";
export const SET_CHARGER_FREE = "SET_CHARGER_FREE";
export const STOP_CHARGER_ON_FAILURE = "STOP_CHARGER_ON_FAILURE";
export const STOP_PENDING_CHARGINGS = "STOP_PENDING_CHARGINGS";
export const HANDLE_INSPECT_CHARGER = "HANDLE_INSPECT_CHARGER";
export const FETCH_BUSES_RESUME = "FETCH_BUSES_RESUME";
export const REINICIO_FORZADO = "REINICIO_FORZADO";
//RESERVAS
export const FETCH_INNER_STATE_CHARGERS = "FETCH_INNER_STATE_CHARGERS";
export const UPDATE_INNER_STATE_CHARGERS = "UPDATE_INNER_STATE_CHARGERS";
export const MAKE_RESERVA = "MAKE_RESERVA";
export const SET_FILTERED_BUSES = "SET_FILTERED_BUSES";
//USUARIOS
export const FETCH_USUARIOS = "FETCH_USUARIOS";
export const FETCH_USER = "FETCH_USER";
export const UPDATE_USERS_MANUALLY = "UPDATE_USERS_MANUALLY";
export const TOGGLE_USER_STATE = "TOGGLE_USER_STATE";
export const SET_CURRENT_PAGE = "CURRENT_PAGE";
export const SET_PAGE_SIZE = "PAGE_SIZE";
export const SET_SEARCH_QUERY = "SEARCH_QUERY";
export const SET_SORT_COLUMN = "SORT_COLUMN";
export const RESET_VIEW_USERS = "RESET_VIEW_USERS";
export const FETCH_USERS_PROFILES = "FETCH_USERS_PROFILES";
export const SET_SELECTED_PROFILE = "SET_SELECTED_PROFILE";
export const UPDATE_USER = "UPDATE_USER";
export const CREATE_NEW_USER = "CREATE_NEW_USER";
export const REQUEST_NEW_USER = "REQUEST_NEW_USER";
export const FETCH_PENDDING_USER = "FETCH_PENDDING_USER";
export const ACCEPT_DECLINE_USER = "ACCEPT_DECLINE_USER";
export const MAKE_USER_INVISIBLE = "MAKE_USER_INVISIBLE";
export const FETCH_TERMINALES = "FETCH_TERMINALES";
//CAMBIA ESTADOS
export const SET_PUESTO = "SET_PUESTO";
export const SET_MARQUESINA = "SET_MARQUESINA";
export const SET_CARGADOR_ORIGEN = "SET_CARGADOR_ORIGEN";
export const SET_SELECTED_CHARGER_STATUS = "SET_SELECTED_CHARGER_STATUS";
export const SET_SELECTED_PPU = "SET_SELECTED_PPU";
export const CHANGE_CHARGER_STATUS = "CHANGE_CHARGER_STATUS";
export const RESET_VALUES_CHANGE_CHARGER_STATUS =
  "RESET_VALUES_CHANGE_CHARGER_STATUS";
export const SET_IS_LOADING_BTN = "SET_IS_LOADING_BTN";

//hISTORIAL
export const FETCH_HISTORIAL = "FETCH_HISTORIAL";
export const FETCH_HISTORIAL_FILTER = "FETCH_HISTORIAL_FILTER";
export const SET_CURRENT_PAGE_HISTORIAL = "SET_CURRENTE_PAGE_HISTORIAL";
export const SET_SEARCH_QUERY_HISTORIAL = "SET_SEARCH_QUERY_HISTORIAL";
export const SET_FILTER_MARQUESINA = "SET_FILTER_MARQUESINA";
export const SET_FILTER_DATE = "SET_FILTER_DATE";
export const SET_SORT_COLUMN_HISTORIAL = "SET_SORT_COLUMN_HISTORIAL";

//ASIGNADOR
export const SHOW_RESERVA = "SHOW_RESERVA";
export const INSERT_RESERVA_SCREEN = "INSERT_RESERVA_SCREEN";

//SOH
export const FETCH_SOH_BUSES = "FETCH_BUSES_SOH";
export const FETCH_SOH_COLS = "FETCH_SOH_COLS";
export const SET_EDITING_MODE = "SET_EDITING_MODE";
export const FETCH_SOH_HISTORY = "FETCH_SOH_HISTORY";
export const CLEAR_SOH_HISTORY = "CLEAR_SOH_HISTORY";
export const UPDATE_SOH = "UPDATE_SOH";
export const CLEAR_SOH = "CLEAR_SOH";

//ADMINISTRACION (CARGADORES, BUSES)
export const SET_CHARGER_SETTINGS_MODAL = "SET_CHARGER_SETTINGS_MODAL";
export const UPDATE_CHARGER_SETTING = "UPDATE_CHARGER_SETTING";
export const CLOSE_MODAL_DATA_SETTINGS = "CLOSE_MODAL_DATA_SETTINGS";
export const COMMIT_CHARGER_SETTING = "COMMIT_CHARGER_SETTING";
export const SET_MODAL_SETTING_LOADING = "SET_MODAL_SETTING_LOADING";

//DERIVACION
export const FETCH_DERIVACION_LIST = "FETCH_DERIVACION_LIST";
export const SET_SELECTED_DERIVACION = "SET_SELECTED_DERIVACION";
export const RESET_DERIVACION_LIST = "RESET_DERIVACION_LIST";
export const MAKE_DERIVACION = "MAKE_DERIVACION";

//PREVENTIVA
export const FETCH_PREVENTIVA = "FETCH_PREVENTIVA";
export const SAVE_PREVENTIVA = "SAVE_PREVENTIVA";
export const DELETE_PREVENTIVA = "DELETE_PREVENTIVA";
export const CLEAR_PREVENTIVA = "CLEAR_PREVENTIVA";

//REPORTES
export const REGISTRA_REPORTE = "REGISTRA_REPORTE";
export const FETCH_REPORTES_TERMINAL = "FETCH_REPORTES_TERMINAL";
export const UPLOAD_FOTOS_REPORTE = "UPLOAD_FOTOS_REPORTE";
export const FETCH_TIPO_REPORTES = "FETCH_TIPO_REPORTES";
export const FILTRA_REPORTES_PISTOLAS = "FILTRA_REPORTES_PISTOLAS";
export const FETCH_ULTIMO_REPORTE_PISTOLA = "FETCH_ULTIMO_REPORTE_PISTOLA";
export const CLEAR_DATA_REPORTES_PISTOLAS = "CLEAR_DATA_REPORTES_PISTOLAS";
